import { GQLPhotoItemFragment } from 'components/page/ForeignProfile/gql/__generated__/Photos'

export const useMobilePhotosNext = (
  photos?: GQLPhotoItemFragment[],
  hasPhotoForSocial?: boolean,
  hasPhotoForTag?: boolean
) => {
  if (photos && photos.length > 0) {
    const _photos = [...photos]
    const main = _photos.filter(({ portrait }) => portrait)
    const restPhotos = _photos.filter(({ portrait }) => !portrait)

    return {
      mainPhoto: main.shift(),
      mobileGoalPhoto: main.shift(),
      mobileInterestsPhoto: hasPhotoForTag ? main.shift() : undefined,
      mobileSocialPhoto: hasPhotoForSocial ? main.shift() : undefined,
      mobilePhotos: [...main, ...restPhotos],
    }
  }

  return {
    mainPhoto: undefined,
    mobileGoalPhoto: undefined,
    mobileInterestsPhoto: undefined,
    mobileSocialPhoto: undefined,
    mobilePhotos: undefined,
  }
}
